import React from "react";

const Icons = () => (
  <svg
    width="0"
    height="0"
    style={{ position: "absolute" }}
    aria-hidden="true"
    focusable="false"
  >
    <symbol id="ic-bell" viewBox="0 0 24 24">
      <path
        d="M18 8a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M13.7 21a2 2 0 0 1-3.4 0"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      ></path>
    </symbol>
    <symbol id="ic-chev" viewBox="0 0 12 12">
      <path
        d="M3 4.5 L6 7.5 L9 4.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </symbol>
    <symbol id="ic-check" viewBox="0 0 24 24">
      <path
        d="M5 13l4 4L19 7"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </symbol>
    <symbol id="ic-clock" viewBox="0 0 24 24">
      <circle
        cx="12"
        cy="12"
        r="8.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.4"
      ></circle>
      <path
        d="M12 7.5V12l3 2"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </symbol>
    <symbol id="ic-retry" viewBox="0 0 24 24">
      <path
        d="M20 11a8 8 0 1 0-1.5 4.7"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
      ></path>
      <path
        d="M20 4v6h-6"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </symbol>
    <symbol id="ic-book" viewBox="0 0 24 24">
      <path
        d="M12 6.6C10 5.3 7 4.7 4 4.7V17.5c3 0 6 .6 8 1.9 2-1.3 5-1.9 8-1.9V4.7c-3 0-6 .6-8 1.9z"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      ></path>
      <path
        d="M12 6.6V19.4"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      ></path>
    </symbol>
    <symbol id="ic-shelf" viewBox="0 0 24 24">
      <rect
        x="4"
        y="4.6"
        width="16"
        height="4.3"
        rx="1.3"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      ></rect>
      <rect
        x="4"
        y="9.85"
        width="16"
        height="4.3"
        rx="1.3"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      ></rect>
      <rect
        x="4"
        y="15.1"
        width="16"
        height="4.3"
        rx="1.3"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      ></rect>
    </symbol>
    <symbol id="ic-heart" viewBox="0 0 24 24">
      <path
        d="M12 21C7 16.5 3 13 3 8.6 3 5.9 5.2 4 7.5 4 9.5 4 11 5.3 12 7 13 5.3 14.5 4 16.5 4 18.8 4 21 5.9 21 8.6 21 13 17 16.5 12 21Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      ></path>
    </symbol>
    <symbol id="ic-play" viewBox="0 0 24 24">
      <path d="M8 5l11 7-11 7z" fill="currentColor"></path>
    </symbol>
    <symbol id="ic-ext" viewBox="0 0 24 24">
      <path
        d="M14 4h6v6M20 4l-9 9M19 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h5"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </symbol>
  </svg>
);

export default Icons;
